import React from 'react';
import { Users, GraduationCap, Laptop, Heart } from 'lucide-react';
import StatCounter from './ui/StatCounter';
import Card3D from './ui/Card3D';
import SectionBackground from './ui/SectionBackground';
import { colors } from '../styles/theme';

const stats = [
  {
    icon: <Users className="w-8 h-8" />,
    value: 198000,
    label: "Registered Students",
    suffix: "+",
    color: colors.primary
  },
  {
    icon: <GraduationCap className="w-8 h-8" />,
    value: 215000,
    label: "Activated Products",
    suffix: "+",
    color: colors.secondary
  },
  {
    icon: <Laptop className="w-8 h-8" />,
    value: 22,
    label: "Projects Supported",
    suffix: "+",
    color: colors.tertiary
  },
  {
    icon: <Heart className="w-8 h-8" />,
    value: 15,
    label: "Active Volunteers",
    suffix: "+",
    color: colors.accent1
  }
];

const Stats: React.FC = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-gray-50 to-white">
      <SectionBackground variant="left" color={colors.primary} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Impact</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Numbers that reflect our commitment to digital inclusion
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <Card3D key={index}>
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div 
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto"
                  style={{
                    backgroundColor: `${stat.color}15`,
                    color: stat.color
                  }}
                >
                  {stat.icon}
                </div>
                <div 
                  className="text-4xl mb-2 text-center"
                  style={{ color: stat.color }}
                >
                  <StatCounter
                    end={stat.value}
                    suffix={stat.suffix}
                  />
                </div>
                <p className="text-gray-600 text-center font-medium">{stat.label}</p>
              </div>
            </Card3D>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;